import React from 'react';
import { Link } from 'gatsby';
import { getAuthorUrl } from '../../model/author';

const AuthorLink = ({ author: { name, slug }, postAuthors, index }) => (
  <>
    <Link to={getAuthorUrl(slug)} className="author-link">
      {name}
    </Link>{' '}
    {!!postAuthors && postAuthors.length > index + 1 && ` & `}
  </>
);

export default AuthorLink;
